<template>
  <div class="container">
    <div class="content" v-html="html"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      html: "",
    };
  },
  created() {
    let aid = this.$route.query.id;
    let from = this.$route.query.from;
    // from === ts，预览调用的详情接口与 TS 端的详情是一个接口
    if (from === "ts") {
      this.$API.getTSArticleDetail({ ts_article_id: aid }).then((res) => {
        if (res.error_code === 0) {
          let article = res.data.info.content;
          article = article.replace(/target=\"_blank\"/, "");
          this.html = article;
          document.title = res.data.info.title;
        }
      });
    } else {
      if (aid) {
        this.$API.getAppArticleDetail({ article_id: aid }).then((res) => {
          if (res.error_code === 0) {
            let article = res.data.article_content;
            article = article.replace(/target=\"_blank\"/, "");
            this.html = article;
          }
        });
      }
    }
  },
};
</script>
<style lang="scss">
.container {
  padding: 0 10px;
  .content {
    border-top: 1px solid #f8f9fa;
    text-align: left;
    padding: 12px;
    table {
      display: flex;
      th,
      td {
        border: 1px solid #aaaaaa;
        padding: 8px;
      }
    }
  }
}
// 适配 PC 端打开页面
@media only screen and (min-width: 1000px) {
  .container {
    padding: 0 10px;
    .content {
      border: 0.1px solid gray;
      margin: 10px auto;
      font-size: 4px;
      padding: 5px;
      width: fit-content;
    }
    img {
      width: auto;
    }
  }
}
</style>
